import { render, staticRenderFns } from "./nextDiscussVote.vue?vue&type=template&id=584597c2&scoped=true&"
import script from "./nextDiscussVote.vue?vue&type=script&lang=js&"
export * from "./nextDiscussVote.vue?vue&type=script&lang=js&"
import style0 from "./nextDiscussVote.vue?vue&type=style&index=0&id=584597c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584597c2",
  null
  
)

export default component.exports